import api from './api'

export const dashboardService = {
  getSummary: () => api.get('/dashboard/summary'),
  
  getSalesChart: (days?: number) => 
    api.get('/dashboard/sales-chart', { params: { days } }),
  
  getInventorySummary: () => 
    api.get('/dashboard/inventory-summary'),
  
  getAlerts: () => 
    api.get('/dashboard/alerts'),
  
  getRecentActivity: (limit?: number) => 
    api.get('/dashboard/recent-activity', { params: { limit } }),
  
  getCustomerCategories: () =>
    api.get('/dashboard/customer-categories'),
  
  getPaymentModes: () =>
    api.get('/dashboard/payment-modes'),
  
  getPaymentAlerts: () =>
    api.get('/dashboard/payment-alerts'),
  
  getPaymentCalendar: (year?: number, month?: number) =>
    api.get('/dashboard/payment-calendar', { params: { year, month } }),
  
  getCustomerTypesSummary: () =>
    api.get('/dashboard/customer-types-summary'),
}
